// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"433177c4","455":"98580466","977":"19b8ffc0"}[chunkId] + ".chunk.js";
};